import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import WarningAmber from "@mui/icons-material/WarningAmber";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { differenceInDays, format, isAfter } from "date-fns";
import { es } from "date-fns/locale";
import { CreditStatus } from "../data/models/applications/CreditApplication";

interface WhatsAppNotifyButtonProps {
  name: string;
  phone: string;
  paymentDate: string | Date;
  status: CreditStatus;
  compact?: boolean;
}

export const WhatsAppNotifyButton: React.FC<WhatsAppNotifyButtonProps> = ({
  name,
  phone,
  paymentDate,
  status,
  compact = false,
}) => {
  const paymentDateObj = new Date(paymentDate);

  const expired = isAfter(new Date(), paymentDateObj) && status !== "FINISHED";
  if (!expired) return null;

  const dias = differenceInDays(new Date(), paymentDateObj);

  const dateFormatted = format(paymentDateObj, "dd 'de' MMMM 'de' yyyy", {
    locale: es,
  });

  const message = `Hola *${name.toUpperCase()}* 👋, tu pago en Prestiya se venció el *${dateFormatted.toUpperCase()}* y tienes *${dias} DÍA(S) de mora*. Por favor realiza el pago y antes de transferir *CONSÚLTANOS LA CUENTA* para evitar errores. Si ya pagaste, ignora este mensaje. 🤝`;

  const handleNotify = () => {
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  if (compact) {
    return (
      <IconButton
        onClick={handleNotify}
        sx={{
          color: "#25D366",
          "&:hover": { backgroundColor: "rgba(37, 211, 102, 0.1)" },
        }}
      >
        <WhatsAppIcon />
      </IconButton>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
        <WarningAmber sx={{ fontSize: 14, color: "#ef4444" }} />
        <Typography variant="caption" color="error">Pago vencido</Typography>
      </Box>

      <Button
        onClick={handleNotify}
        fullWidth
        variant="contained"
        startIcon={<WhatsAppIcon />}
        style={{
          padding: "8px 16px",
          borderRadius: 4,
          margin: "8px 0px",
          backgroundColor: "#25D366",
        }}
      >
        Notificar por WhatsApp
      </Button>
    </>
  );
};
